var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartTypeBarStackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 7,
    width: 3,
    height: 5,
    fill: "var(--report-graph-bar-stack-color)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 13,
    width: 3,
    height: 5,
    fill: "#FF6D10"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 1,
    width: 3,
    height: 8,
    fill: "var(--report-graph-bar-stack-color)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 10,
    width: 3,
    height: 8,
    fill: "#FF6D10"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 5,
    width: 3,
    height: 6,
    fill: "var(--report-graph-bar-stack-color)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 12,
    width: 3,
    height: 6,
    fill: "#FF6D10"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartTypeBarStackIcon);
export default __webpack_public_path__ + "static/media/chart-type-bar-stack-icon.531fd1799de649d402ac656d95496166.svg";
export { ForwardRef as ReactComponent };